import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#3DC4B9',
        // secondary: '#7C8388',
        secondary: '#BA567C',
        accent: '#334EFF',
        error: '#FF3333',
        info: '#8C97A1',
        success: '#17CF79',
        warning: '#FFBB33',
      },
    },
  },
});



// WEBPACK FOOTER //
// ./src/js/vuetify.js